import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import { WhatsAppFloat } from "./components/site/WhatsAppFloat";
import { GalleryMarquee } from "./components/site/GalleryMarquee";
import { ScrollToTop } from "./components/site/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Infrastructure from "./pages/Infrastructure";
import Products from "./pages/Products";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <GalleryMarquee />
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
